import { render } from "./M19CommentMaterialsModal.vue?vue&type=template&id=6094bf6c&scoped=true"
import script from "./M19CommentMaterialsModal.vue?vue&type=script&lang=js"
export * from "./M19CommentMaterialsModal.vue?vue&type=script&lang=js"

import "./M19CommentMaterialsModal.vue?vue&type=style&index=0&id=6094bf6c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6094bf6c"]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QMarkupTable,QSpace,QBtn,QDialog,QCard,QCardSection,QIcon,QSeparator,QExpansionItem,QCardActions});qInstall(script, 'directives', {ClosePopup});
